module.exports = __webpack_public_path__ + "static/img/viral_20.edc4dc78.jpg";